export const STATIC_IMG_PATH = "/-/public/img";

export const KNOWLEDGE_BASE_URL = "https://lifetraq.com/knowledge-base/";

export const LIFETRAQ_URL = "https://lifetraq.com";

export const TRAQIFY_URL = "https://www.traqify.co";

export const LIFETRAQ_LOGO_FILENAME = "logo.svg";

export const SCDC_LOGO_FILENAME = "logo_scdc.png";

export const TRAQIFY_LOGO_FILENAME = "logo_traqify.svg";

export const LIFETRAQ_LOGO_URL = `${STATIC_IMG_PATH}/${LIFETRAQ_LOGO_FILENAME}`;
export const SCDC_LOGO_URL = `${STATIC_IMG_PATH}/${SCDC_LOGO_FILENAME}`;
export const TRAQIFY_LOGO_URL = `${STATIC_IMG_PATH}/${TRAQIFY_LOGO_FILENAME}`;
